import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Frame shared by login / signup / forgot / reset.
 *
 * Two panels above `lg`: a navy brand panel and the form. Below that the brand
 * panel collapses to a compact header so the form stays above the fold on a
 * phone — a full-height hero would push the password field under the keyboard.
 */
const AuthLayout = ({ title, subtitle, children, footer }) => (
  <div className="flex min-h-[100dvh] flex-col lg:flex-row">
    {/* Brand panel */}
    <div className="relative flex shrink-0 items-center overflow-hidden bg-primary px-6 py-8 lg:w-[45%] lg:px-12 lg:py-0">
      {/* Soft radial wash so the flat navy doesn't read as a dead rectangle. */}
      <div
        className="pointer-events-none absolute inset-0 opacity-40"
        style={{
          background:
            'radial-gradient(60rem 40rem at 20% 20%, rgb(var(--color-accent) / 0.35), transparent 60%)',
        }}
        aria-hidden="true"
      />

      <div className="relative mx-auto w-full max-w-md">
        <Link to="/" className="flex items-center gap-3">
          <img src="/images/rgalogo.png" alt="" className="h-10 w-10 object-contain lg:h-12 lg:w-12" />
          <span className="text-xl font-semibold tracking-tight text-white lg:text-2xl">
            RGA Reports
          </span>
        </Link>

        <div className="hidden lg:mt-10 lg:block">
          <h2 className="text-3xl font-semibold leading-tight text-white">
            Maintenance reporting for airport operations.
          </h2>
        </div>
      </div>
    </div>

    {/* Form panel */}
    <div className="flex flex-1 items-center justify-center bg-background px-4 py-10 sm:px-6">
      <div className="w-full max-w-sm">
        <h1 className="text-2xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="mt-1.5 text-sm text-muted-fg">{subtitle}</p>}

        <div className="mt-7">{children}</div>

        {footer && <div className="mt-6 text-center text-sm text-muted-fg">{footer}</div>}
      </div>
    </div>
  </div>
);

/** Inline link styling shared by the auth footers. */
export const AuthLink = ({ to, children }) => (
  <Link
    to={to}
    className="rounded font-medium text-accent transition-colors duration-fast hover:text-accent-hover hover:underline"
  >
    {children}
  </Link>
);

export default AuthLayout;
